import React from "react";
import HotelCard from "./SingleProperty";

const HotelList = ({ properties }) => {
  if (!Array.isArray(properties)) {
    return <p>No properties available</p>;
  }

  return (
    <div className="hotel-list">
      {properties.map((property, index) => (
        <HotelCard key={index} property={property} />
      ))}
    </div>
  );
};

export default HotelList;
